import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import { HaveFinish, PriceKey } from 'utils/finishes';

interface CalculatePriceCard {
  wantListId: number;
  cardId?: string;  // Specific card ID for exact version matching
  condition: string;
  language: string;
  /** Authoritative (Track D); sent with the derived `foil` through D */
  finish?: HaveFinish;
  foil: boolean;
  set?: string;
}

interface CalculatePriceRequest {
  cards: CalculatePriceCard[];
}

interface CalculatePriceResponse {
  cards: Array<{
    wantListId: number;
    displayPrice: number;
    languageMultiplierApplied?: boolean;
    multiplierValue?: number;
    /** The Price column used (backend Track A); null when no price resolved (the unitPrice 0 case). */
    priceKey?: PriceKey | null;
    /** Echoed finish (Track D) */
    finish?: HaveFinish;
  }>;
}

export const tradePriceApi = createApi({
  reducerPath: 'tradePriceApi',
  baseQuery,
  endpoints: (builder) => ({
    calculatePrice: builder.mutation<CalculatePriceResponse, CalculatePriceRequest>({
      query: (data) => ({
        url: '/trades/calculate-price',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useCalculatePriceMutation } = tradePriceApi;